module.exports = __webpack_public_path__ + "media/assets/icons/review_star-1f701cb262d2155c70b6f2ed129d5c7f.svg";